import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { Button, Text } from '@beef/ui-kit';

import { ErrorCat } from 'assets';
import { ERROR_TEXTS } from 'constants/index';

import { Image } from '../Image';
import { ErrorType } from './types';
import styles from './styles.pcss';

const cn = classNames.bind(styles);

export const Error: FC<ErrorType> = ({
  title = ERROR_TEXTS.error.title,
  description = ERROR_TEXTS.error.text,
  src,
  iconClass,
  className,
  withoutImage = false,
  children = null,
  buttonName,
  handleClick,
  isCompact = false,
  titleSize = 'size3-m',
  descriptionSize = 'size5-r-l',
}) => (
  <div className={cn('wrap', className)}>
    {!!children && withoutImage && children}
    {!withoutImage && (
      <div className={cn('icon', iconClass)}>
        {src ?
          <Image data-testid="error-image" height="200" src={src} width="200" />
        : <ErrorCat data-testid="error-image" />}
      </div>
    )}
    {title && (
      <div className={cn('mar-b-2xs', { [className]: !isCompact })}>
        <Text size={titleSize}>{title}</Text>
      </div>
    )}
    {description && (
      <div className={cn({ [className]: !isCompact })}>
        <Text color="grey60" size={descriptionSize}>
          {description}
        </Text>
      </div>
    )}
    {handleClick && (
      <div className={cn('button')}>
        <Button onClick={handleClick} size="m" variant="main">
          {buttonName}
        </Button>
      </div>
    )}
  </div>
);
